<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import $ from "jquery";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";

export default {
  name: "ProductsManagement",
  components: {BottomNavigation, LoadingPage},

  setup() {


    let loading = ref(false)
    let categories = ref([])

    function load_category() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'shop/categories', true).then((res) => {

        loading.value = false
        categories.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_category)
      })

    }
    load_category()


    function open_category(id) {
      let div = document.getElementById('cat' + id);
      let icon = $("#svg_cat" + id);

      let rootFontSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('font-size'));
      let heightInRem = div.scrollHeight / rootFontSize;
      heightInRem = heightInRem.toFixed(1);

      if (div.style.height === heightInRem + 'rem') {
        div.style.height = '4.1rem';
        icon.removeClass('rotate_icon').addClass('min_rotate_icon');
      } else {
        div.style.height = heightInRem + 'rem'; // Set height based on content
        icon.removeClass('min_rotate_icon').addClass('rotate_icon');
      }
    }

    return {

      categories,
      open_category,
      loading,

    }
  }
}
</script>


<template>

    <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مدیریت محصولات</p>
        <router-link :to="{name:'HomePage'}">
        <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="w-100 p-body overflow-hidden py-3">

            <div v-if="categories.length === 0 && !loading" style="height: 45vh" class="animate__animated animate__fadeIn d-flex flex-column justify-content-end align-items-center">
              <img src="../assets/img/empty.png" style="width:100px;height: 100px">
              <p class="mt-3 font-4 text-dark">آیتمی برای نمایش وجود ندارد</p>
            </div>


      <div v-else-if="categories.length > 0 && !loading" class="w-100">
        <p class="mt-3 font-4 font-bold">دسته بندی محصولات شما</p>

        <router-link :to="{name:'ProductsPage',params:{sub_id:0 , sub_name:'همه محصولات'}}" class="animate__animated animate__fadeInRight text-decoration-none mt-2 py-2 px-2 bg-white shadow-custom w-100 rounded-5 d-flex justify-content-start align-items-center ">
          <img src="../assets/img/allp.png" class="icon_category p-2 rounded-pill bg-color">
          <p class="font-color me-3 font-4 font-bold">همه محصولات</p>
        </router-link>

        <div v-for="item in categories" :key="item.id" :id="'cat' + item.id" class="category animate__animated animate__fadeInRight mt-2 pt-2 pb-4 px-2 bg-white shadow-custom w-100 rounded-5 overflow-hidden">
          <div @click="open_category(item.id)" class="d-flex justify-content-between align-items-center ">
            <div class="d-flex justify-content-center align-items-center">
              <img src="../assets/img/allp.png" class="icon_category p-2 rounded-pill bg-color">
              <p class="m-0 me-3 font-4 font-bold font-color">{{ item.name }}</p>
            </div>
            <img src="../assets/img/bottarrow.png" :id="'svg_cat' + item.id" class="ml-3" style="width: 13px">
          </div>

          <div class="div_hr my-4"></div>


          <router-link :to="{name:'ProductsPage',params:{sub_id:cat.id , sub_name:cat.name}}" v-for="cat in item.subcategory" :key="cat.id" class="mt-2 text-decoration-none rounded-4 p-2 bg-color-blue-light w-100 p-body d-flex justify-content-center">
            <p class="text-decoration-none text-black text-center font-bold font-4">{{ cat.name }}</p>
          </router-link>

        </div>
      </div>

      <div dir="ltr" class="position-fixed max_width w-100" style="bottom: 12%">
        <router-link :to="{name:'AddProducts',params:{action:'new'}}">
          <img src="../assets/img/icon_add_products.svg" class="ml-5" style="width: 60px;height: 60px">
        </router-link>
      </div>

    </div>



  </div>

    <BottomNavigation></BottomNavigation>

</template>


<style scoped>

.icon_category {
  width: 3rem;
  height: 3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}
.category{
  transition: .5s;
  height: 4.1rem;
}
.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(0deg);
  transition: .5s;
}

</style>